import React, {useEffect} from "react";
import SubTitle from "../../components/SubTitle";
import {useForm, FormProvider, SubmitHandler} from "react-hook-form";
import {useGetItemQuery, useGetQuery, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";
import {useLocation, useNavigate, useParams} from "react-router-dom";

import * as Params from "../../models/clientModels/interfaces/apiParams";
import * as dangerEvaluationCheckItem from "../../api/permissionApi/dangerEvaluationCheckItem";

import {useQuery, useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import MWProgress from "../../components/MWProgress";
import {tokenSelector} from "../../Recoil/Atom/authState";

import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import CheckItemForm from "./CheckItemForm";
import {InitialCheckItemParams} from "../../models/serverModels/permission/WPCheckItem";
import {WPCheckItem} from "../../models/serverModels/permission/WPCheckItem";
import {initializeCheckItem} from "../../models/serverModels/permission/WPCheckItem";

const checkItemSchema = yup.object({
  name: yup.string().required("아이템명을 입력해주세요"),
  displayOrder: yup.number(),
});
const UpdateCheckItem = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {data: checkItem, isLoading: isGetLoading} = useQuery(
    ["EvaluationCheckItem", {token: tokenState, id: parseInt(id!)}],
    () => dangerEvaluationCheckItem.getItem({token: tokenState, id: parseInt(id!)})
  );

  const {mutate: updateMutate, isLoading: isUpdateLoading} = useUpdateMutation<
    ResponseItem<WPCheckItem>,
    Params.Update<WPCheckItem>
  >({
    api: dangerEvaluationCheckItem.update,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("update");
        navigate(`/Permission/CheckItemList/${checkItem?.item?.categoryIndex}`);
        queryClient.invalidateQueries("CheckItemList");
      },
    },
  });

  const methods = useForm<WPCheckItem>({
    defaultValues: checkItem?.item || initializeCheckItem(),
    resolver: yupResolver(checkItemSchema),
  });

  const {reset} = methods;

  useEffect(() => {
    reset(checkItem?.item);
  }, [checkItem?.item, reset]);

  const onSubmit: SubmitHandler<WPCheckItem> = (data) => {
    updateMutate({
      id: parseInt(id!),
      token: tokenState,
      item: {...initializeCheckItem(), ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="유해위험요인 수정" />
      {isUpdateLoading && <MWProgress />}
      {isGetLoading ? (
        <MWProgress />
      ) : (
        <FormSection>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <CheckItemForm />
            <ConfirmButtonGroup
              link={`/Permission/CheckItemList/${checkItem?.item?.categoryIndex}`}
              cancelText="취소"
              confirmText="수정"
            />
          </form>
        </FormSection>
      )}
    </FormProvider>
  );
};

export default UpdateCheckItem;
